import React from 'react';
import { Button } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Buttons from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Loading from '../../loadings';
import Server from '../../../functions/server'
import $ from "jquery";

class AddCombo extends React.Component {

  state = {
    
  }

  addCombo() {
    let context = this;
    context.setState({ load: true, message: 'Add Combo!!!' });
    $.ajax({
        type: 'POST',
        data: { 'name': context.state.combo_name, 'status': 'Active', 'by': 13 },
        url: Server() + 'combo/add.php',
        success: function(data) {
            context.setState({ load: false });
            if (data == 1) {
                context.setState({ openAddComboDialog: false })
                context.props.getCombos();
            }
            else {
                alert('Error to Save Data!!!')
            }
        },
        error: function(e) {
            alert('Try again!!')
            context.setState({
            load: false
            });
        }
    });
  }

  onChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    let  { openAddComboDialog, load, message } = this.state;
    const { fullScreen } = this.props;
    return (
      <div>
        <Loading load={load} message={message} />
        <Button onClick={ () => { this.setState({ openAddComboDialog: true }) }}>Add</Button><br/><br/>
        <Dialog fullScreen={fullScreen} open={openAddComboDialog}
          onClose={ () => { this.setState({ openAddComboDialog: false }) }} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 400}}>{"Add Combo"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
                <form noValidate autoComplete="off">
                <TextField
                    id="outlined-name"  label="Combo Name"
                    value={this.state.combo_name} fullWidth
                    onChange={this.onChange('combo_name')}
                    margin="normal" variant="outlined" />
                </form>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={ () => { this.setState({ openAddComboDialog: false }) }} color="secondary">
              NO
            </Buttons>
            <Buttons onClick={this.addCombo.bind(this)} color="primary" autoFocus>
              Yes
            </Buttons>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddCombo;
